import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { applySession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/login"); return; }
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        const user = applySession(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "customer" ? "/portal" : "/app", { replace: true });
      })
      .catch(() => navigate("/login?error=google"));
  }, [applySession, navigate]);

  return (
    <div className="min-h-screen bg-navy-900 flex flex-col items-center justify-center gap-4">
      <LogoMark size={56} />
      <p className="text-gold-500 animate-pulse">Anmeldung wird abgeschlossen…</p>
    </div>
  );
}
